import { render, staticRenderFns } from "./PaymentCaptureBlock.vue?vue&type=template&id=eff12540&scoped=true&"
import script from "./PaymentCaptureBlock.vue?vue&type=script&lang=js&"
export * from "./PaymentCaptureBlock.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCaptureBlock.vue?vue&type=style&index=0&id=eff12540&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eff12540",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eff12540')) {
      api.createRecord('eff12540', component.options)
    } else {
      api.reload('eff12540', component.options)
    }
    module.hot.accept("./PaymentCaptureBlock.vue?vue&type=template&id=eff12540&scoped=true&", function () {
      api.rerender('eff12540', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/PaymentCaptureBlock.vue"
export default component.exports